import React from 'react';
import { useLocation } from 'react-router-dom';

import CommonNavigation from "../../header/CommonNavigation";
import Paths from "../../../types/Paths";
import CheckoutHeader from "../../checkout/header/CheckoutHeader";
import MenuPosition from "../../../types/MenuPosition";

const HeaderSelector = ({}) => {
  const { pathname } = useLocation();
  let HeaderComponent;

  if (pathname.endsWith(Paths.ProposalCheckout)) {
    HeaderComponent = <CheckoutHeader menuPosition={MenuPosition.PROPOSAL_REQUEST} />;
  } else if (pathname.endsWith(Paths.Checkout)) {
    HeaderComponent = <CheckoutHeader menuPosition={MenuPosition.CHECKOUT} />;
  } else {
    HeaderComponent = <CommonNavigation />;
  }

  return HeaderComponent;
};

export default HeaderSelector;
